// Getters
export const ACCEDE_SENS_DISPOS = "sens/accede_dispos";
export const ACCEDE_SEN_PAR_MATRICULE = "sens/accede_par_matricule";
export const ACCEDE_TYPURL_PAR_CODE = "types_urls/accede_par_code";
export const ACCEDE_EVTS = "events/accede";

// Mutations
export const MODIFIE_SENS_DISPOS = "sens/change_dispos";
export const MODIFIE_TYPURLS = "types_urls/change_types";
export const MODIFIE_EVTS = "events/definit";

// Actions
export const CHARGE_SENS_DISPOS = "sens/charge_dispos";
export const CHARGE_TYPURLS = "types_url/charge";
export const CHARGE_EVTS_PAR_MATRICULE = "events/charge_par_matricule";



// WEBPACK FOOTER //
// ./src/store/types.js